/**
 * Creates CSS styles for the shadow DOM
 * @param {Object} dims         - Initial dimensions { width, height }
 * @param {string} aspect_ratio - Aspect ratio in format "16:9"
 * @param {string} margin_x     - Horizontal margin
 * @param {string} margin_y     - Vertical margin
 * @return {string} CSS styles as string
 */
export const createShadowStyles = (dims, aspect_ratio, margin_x, margin_y) => {
	const cssAspectRatio = aspect_ratio.replace(':', '/');

	return `
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }

    #pingvid-wrapper {
      position: fixed;
      z-index: 999999;
      display: none;
      width: ${dims.width}px;
      height: ${dims.height}px;
      border-radius: 12px;
      aspect-ratio: ${cssAspectRatio};
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    }

    #pingvid-wrapper.visible {
      display: block;
      animation: slideIn 0.4s ease-out forwards;
    }

    /* Desktop expanded state - expand in place */
    #pingvid-wrapper.expanded {
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
      z-index: 9999999;
    }
    
    #pingvid-wrapper.expanded #pingvid-video-container {
      border-radius: 16px;
    }
    
    /* Transitioning state */
    #pingvid-wrapper.transitioning {
      transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }

    /* Position classes */
    #pingvid-wrapper.bottom-right {
      bottom: ${margin_y};
      right: ${margin_x};
    }

    #pingvid-wrapper.bottom-left {
      bottom: ${margin_y};
      left: ${margin_x};
    }

    #pingvid-wrapper.top-right {
      top: ${margin_y};
      right: ${margin_x};
    }

    #pingvid-wrapper.top-left {
      top: ${margin_y};
      left: ${margin_x};
    }
    
    /* Desktop specific expanded dimensions */
    @media (min-width: 769px) {
      #pingvid-wrapper.expanded {
        /* Use 2.77x multiplier for all aspect ratios */
        width: calc(${dims.width}px * 2.77) !important;
        height: calc(${dims.height}px * 2.77) !important;
      }
      
      #pingvid-wrapper.expanded.bottom-right {
        bottom: ${margin_y};
        right: ${margin_x};
      }
      
      #pingvid-wrapper.expanded.bottom-left {
        bottom: ${margin_y};
        left: ${margin_x};
      }
      
      #pingvid-wrapper.expanded.top-right {
        top: ${margin_y};
        right: ${margin_x};
      }
      
      #pingvid-wrapper.expanded.top-left {
        top: ${margin_y};
        left: ${margin_x};
      }
    }

    /* Mobile expanded state - center on screen */
    @media (max-width: 768px) {
      #pingvid-wrapper.mobile-expanded {
        width: 90vw !important;
        height: auto !important;
        max-height: 90vh !important;
      }

      #pingvid-wrapper.expanded {
        position: fixed !important;
        top: 50% !important;
        left: 50% !important;
        right: auto !important;
        bottom: auto !important;
        transform: translate(-50%, -50%) !important;
        margin: 0 !important;
      }
    }


    @keyframes slideIn {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    #pingvid-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.01);
      cursor: pointer;
      z-index: 2;
      transition: opacity 0.3s;
    }

    #pingvid-overlay:hover {
      background: rgba(0, 0, 0, 0.05);
    }

    #pingvid-overlay.hidden {
      display: none;
    }

    #pingvid-video-container {
      position: relative;
      width: 100%;
      height: 100%;
      background: #000;
      border-radius: 12px;
      overflow: hidden;
    }

    #pingvid-iframe {
      width: 100%;
      height: 100%;
      border: none;
    }

    #pingvid-close {
      position: absolute;
      top: -14px;
      right: -14px;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.7);
      border: 3px solid white;
      color: white;
      padding: 0;
      line-height: 1;
      min-height: unset;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      z-index: 3;
      transition: all 0.2s;
      backdrop-filter: blur(10px);
    }

    #pingvid-close:hover {
      background: rgba(0, 0, 0, 0.9);
      transform: scale(1.1);
    }

    #pingvid-close:active {
      transform: scale(0.95);
    }
  `;
};
